module.exports = __webpack_public_path__ + "static/media/group-group-enable.fb66c1f2.svg";